var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-card',[_c('v-data-table',{staticClass:"clickable",attrs:{"headers":_vm.columns,"hide-default-footer":_vm.items.length < _vm.pagination.itemsPerPage,"items":_vm.items,"options":_vm.pagination,"loading":_vm.loading},on:{"click:row":_vm.clickRow},scopedSlots:_vm._u([{key:"item.installmentValue",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("real")(item.installmentValue))+" ")]}},{key:"item.totalAmount",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("real")(item.totalAmount))+" ")]}},{key:"item.charges",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("real")(item.charges))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }